export default "__VITE_ASSET__BgX2DN5u__"